import React from 'react'

import { Avatar, ToolbarButton } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import * as S from './styled'

type Props = {
  nickname: string
  avatarUrl?: string
  onRemove?: () => void
}

export const SelectedMember = ({ nickname, avatarUrl, onRemove }: Props) => (
  <S.Container>
    <Avatar name={nickname} imageUrl={avatarUrl} />
    <S.Nickname>{nickname}</S.Nickname>
    <ToolbarButton icon={CloseIcon} onClick={onRemove} />
  </S.Container>
)
